import { AutoColumn } from 'components/Column'
import IntroCard from 'components/IntroCard'
import { LoadingRows } from 'pages/Pool/styleds'
import React, { useContext } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { ThemeContext } from 'styled-components'
import { HideSmall, TYPE } from 'theme'
import {
  ButtonRow,
  GridContainer,
  GridContainerForCard,
  MainContentWrapper,
  NoLiquidity,
  PageWrapper,
  ResponsiveButtonPrimary,
  TitleRow,
  GridContainerForAllCard,
} from './styled'
import { API_POOL_BASE_URL } from 'constants/links'
import { Helmet } from 'react-helmet'
import axios from 'axios'
import MetricsTVL from './MetricsTVL'
import Metrics from './Metrics'
import Filters from './Filters'
import SearchBar from './SearchBar'
import PoolCard from './PoolCard'

import Row from 'components/Row'
import Pagination from './Pagination'
import SortBy from './SortBy'
import MetricsFees from './MetricsFees'
import PoolAllCard from './PoolAllCard'
import { useRewards, useAllCampaigns } from 'hooks/merkle/useCampaigns'
interface Reserves {
  reserve0: string
  reserve1: string
}

interface Token {
  tokenAddress: string
  tokenName: string
  tokenSymbol: string
  tokenDecimal: number
}

interface Pair {
  pairAddress: string
  token0: Token
  token1: Token
  reserves: Reserves
}

const TOTAL_PER_PAGE = 10

const FILTER_QUERY_PARAM = 'filter'

export type sortByEnums = 'tvl' | 'apr' | 'volume' | 'incentives'

const ExplorePools = () => {
  const history = useHistory()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const filter = queryParams.get(FILTER_QUERY_PARAM) || ''
  const [lpLoading, setLpLoading] = React.useState(false)
  const [data, setData] = React.useState<Pair[]>([])
  const theme = useContext(ThemeContext)
  const [currentPage, setCurrentPage] = React.useState(0)
  const [pageCount, setPageCount] = React.useState<number>(1)
  const [searchTerm, setSearchTerm] = React.useState('')
  const [sortBy, setSortBy] = React.useState<sortByEnums>('tvl')
  const { campaigns, isLoading: campaignsLoading } = useAllCampaigns()
  const { rewards } = useRewards()

  const isLeverage = filter === 'leverage'
  const isHot = filter === 'hyped'
  const isIncentives = filter === 'incentives'

  React.useEffect(() => {
    setCurrentPage(0)
  }, [filter])

  /* Incentives Pools */
  React.useEffect(() => {
    const fetchIncentivesPools = async () => {
      if (isIncentives && campaigns.length > 0 && !campaignsLoading) {
        try {
          setLpLoading(true)
          setData([])
          setCurrentPage(0)

          let requests: any[] = []
          campaigns.forEach((campaign) => {
            const type = campaign.type
            const poolAddress = campaign.params.poolAddress
            const token0 = campaign.params.token0
            const token1 = campaign.params.token1
            const token0v2 = campaign.params?.univ2?.token0
            const token1v2 = campaign.params?.univ2?.token1
            const fee = parseFloat(campaign.params.poolFee) * 10000

            if (poolAddress && token0 && token1 && fee && type === 'CLAMM') {
              const url = `${API_POOL_BASE_URL}/api/pairs?version=v3&token0=${token0}&token1=${token1}&fee=${fee}`
              const url2 = `${API_POOL_BASE_URL}/api/pairs?version=v3&token0=${token1}&token1=${token0}&fee=${fee}`

              requests.push(axios.get(url))
              requests.push(axios.get(url2))
            }

            if (type === 'ERC20' && campaign.params.symbolTargetToken === 'SWAP-LP' && token0v2 && token1v2) {
              const url = `${API_POOL_BASE_URL}/api/pairs?version=v2&token0=${token0v2}&token1=${token1v2}`
              const url2 = `${API_POOL_BASE_URL}/api/pairs?version=v2&token0=${token1v2}&token1=${token0v2}`

              requests.push(axios.get(url))
              requests.push(axios.get(url2))
            }
          })

          const responses = await Promise.all(requests)
          const pairs = responses.map((response) => response.data.data.pairs).flat()

          setData(pairs)

          const tableTopElement = document.getElementById('table-top')
          if (tableTopElement) {
            const yOffset = -15
            const y = tableTopElement.getBoundingClientRect().top + window.pageYOffset + yOffset
            window.scrollTo({ top: y, behavior: 'smooth' })
          }
        } catch (error) {
          console.error('Fetch Error:', error)
        } finally {
          setLpLoading(false)
        }
      }
    }

    fetchIncentivesPools()
    //eslint-disable-next-line
  }, [isIncentives, campaignsLoading])

  /* Leverage Pools */
  React.useEffect(() => {
    const fetchDataForLeveragePool = async () => {
      setLpLoading(true)
      const pools = [
        '0xc53F8EA77FaD9a896440675d4E21ABe50F40321f',
        '0xc62f47203F2C1038A528293c6662d1Db0599Ce94',
        '0xd2735f40dB3B1ab7020AbfdEf224845dfC47E279',
        '0x7Db294F26c753ce4FA54A1577aeF7f837ea91fDC',
        '0x8D64d8273a3D50E44Cc0e6F43d927f78754EdefB',
        '0xceaA644eE9c3610F6E36e47b92C358C5E5b647a7',
        '0xE6111Ad7589E41b71D8b530957CB4b2C0069F615',
        '0x3A36B04bcC1D5E2E303981eF643D2668E00b43e7',
        '0x719D7F4388cb0eFb6A48F3c3266e443edCE6588a',
        '0xe8D06Cb860522cDFBE795F15a113329Eb4920f36',
        '0x0237B44bbd51e665D61fEfEc5F97bf88687eD9ca',
      ]

      try {
        setData([])

        const request = axios.post(`${API_POOL_BASE_URL}/api/pairs/by-pair-addresses`, {
          addresses: pools,
        })
        const response = await request
        setCurrentPage(0)

        setData(response.data.data.pairs)
        const tableTopElement = document.getElementById('table-top')
        if (tableTopElement) {
          const yOffset = -15
          const y = tableTopElement.getBoundingClientRect().top + window.pageYOffset + yOffset

          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      } catch (error) {
        console.error('Fetch Error:', error)
        setLpLoading(false)
      } finally {
        setLpLoading(false)
      }
    }

    if (isLeverage) {
      fetchDataForLeveragePool()
    }
  }, [isLeverage])

  /* Hyped Pools */
  React.useEffect(() => {
    const fetchHotPools = async () => {
      setLpLoading(true)
      try {
        setData([])
        setCurrentPage(0)
        const response = await axios.get(`${API_POOL_BASE_URL}/api/pairs?minApr=50&minTvl=50000&maxPerPage=50`)

        if (response.data.success) {
          setData(response.data.data.pairs)
          const tableTopElement = document.getElementById('table-top')
          if (tableTopElement && response.data.data.pairs.length > 0) {
            const yOffset = -15
            const y = tableTopElement.getBoundingClientRect().top + window.pageYOffset + yOffset

            window.scrollTo({ top: y, behavior: 'smooth' })
          }
        } else {
          setData([])
          throw new Error('Failed to fetch data')
        }
      } catch (error) {
        console.error('Fetch Error:', error)
        setLpLoading(false)
      } finally {
        setLpLoading(false)
      }
    }

    if (isHot) {
      fetchHotPools()
    }
  }, [isHot])

  /* V2/V3 Pools */
  React.useEffect(() => {
    const fetchV2V3Pools = async (page: number, tokenName = '', sortBy = '') => {
      setLpLoading(true)
      try {
        setData([])
        const response = await axios.get(`${API_POOL_BASE_URL}/api/pairs`, {
          params: {
            ...(sortBy && sortBy !== 'tvl' ? { sort: sortBy } : {}),
            page: page,
            maxPerPage: TOTAL_PER_PAGE,
            ...(tokenName && tokenName.length > 0 ? { tokenName } : {}),
            ...((filter && filter === 'v2') || 'v3' ? { version: filter } : {}),
          },
        })

        if (response.data.success) {
          setData(response.data.data.pairs)
          setPageCount(response.data.data.pageCount)
          const tableTopElement = document.getElementById('table-top')
          if (tableTopElement && response.data.data.pairs.length > 0) {
            const yOffset = -15
            const y = tableTopElement.getBoundingClientRect().top + window.pageYOffset + yOffset

            window.scrollTo({ top: y, behavior: 'smooth' })
          }
        } else {
          setData([])
          throw new Error('Failed to fetch data')
        }
      } catch (error) {
        console.error('Fetch Error:', error)
        setLpLoading(false)
      } finally {
        setLpLoading(false)
      }
    }

    if (filter === 'v2' || filter === 'v3') {
      fetchV2V3Pools(currentPage, searchTerm, sortBy)
    }
  }, [filter, sortBy, currentPage, searchTerm])

  /* All Pools */
  React.useEffect(() => {
    const fetchData = async (page: number, tokenName = '', sortBy = '') => {
      setLpLoading(true)
      try {
        setData([])
        const response = await axios.get(`${API_POOL_BASE_URL}/api/pairs/aggregated`, {
          params: {
            ...(sortBy && sortBy !== 'tvl' ? { sort: sortBy } : {}),
            page: page,
            maxPerPage: TOTAL_PER_PAGE,
            ...(tokenName && tokenName.length > 0 ? { tokenName } : {}),
          },
        })

        if (response.data.success) {
          setData(response.data.data.pairs)
          setPageCount(response.data.data.pageCount)
          const tableTopElement = document.getElementById('table-top')
          if (tableTopElement && response.data.data.pairs.length > 0) {
            const yOffset = -15
            const y = tableTopElement.getBoundingClientRect().top + window.pageYOffset + yOffset

            window.scrollTo({ top: y, behavior: 'smooth' })
          }
        } else {
          setData([])
          throw new Error('Failed to fetch data')
        }
      } catch (error) {
        console.error('Fetch Error:', error)
        setLpLoading(false)
      } finally {
        setLpLoading(false)
      }
    }

    const delayDebounceFn = setTimeout(() => {
      if (!isLeverage && !isHot && filter !== 'v2' && filter !== 'v3' && filter !== 'incentives') {
        fetchData(currentPage, searchTerm, sortBy)
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm, currentPage, sortBy, filter, isLeverage, isHot])

  const handlePageChange = (newPage: number) => {
    if (newPage >= 0 && newPage < pageCount) {
      setCurrentPage(newPage)
    }
  }

  const switchFilter = (value: string) => {
    const params = new URLSearchParams(location.search)
    if (value) {
      setData([])
      params.set(FILTER_QUERY_PARAM, value)
    } else {
      setData([])
      params.delete(FILTER_QUERY_PARAM)
    }
    history.push({ search: params.toString() })
  }

  const isSortableData = !isLeverage && !isHot && !isIncentives

  return (
    <>
      <Helmet>
        <title>Explore Pools | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="Discover all liquidity pools on HyperSwap Exchange. Built on Hyperliquid, our pools offer optimal earning opportunities for liquidity providers."
        />
        <meta
          name="keywords"
          content="HyperSwap pools, liquidity pools, Hyperliquid blockchain, DEX pools, DeFi, decentralized finance, Hyperliquid EVM"
        />
        <meta property="og:title" content="Explore Pools | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="Explore and invest in liquidity pools on HyperSwap Exchange, leveraging Hyperliquid's fast and secure EVM."
        />
        <meta property="og:url" content={`${window.location.origin}/#/explore/explore-pools`} />
      </Helmet>
      <PageWrapper>
        <AutoColumn gap="lg" justify="center">
          <div style={{ width: '100%' }}>
            <IntroCard variant={1} Key="Explore-pools">
              <h1>Explore Pools</h1>
              <p>Discover all Liquidity Pools.</p>
            </IntroCard>
          </div>

          <AutoColumn gap="lg" style={{ width: '100%' }}>
            <GridContainer>
              <MetricsTVL />
              <Metrics />
              <MetricsFees />
            </GridContainer>
            <TitleRow padding={'0'} id="table-top">
              <HideSmall>
                <TYPE.mediumHeader>
                  {filter === 'leverage' && 'Ecosystem Pools Overview'}
                  {filter === 'hyped' && 'Hyped Pools Overview'}
                  {(filter === '' || filter === undefined) && 'Pools Overview'}
                  {filter === 'incentives' && 'Incentivized Pools Overview'}
                </TYPE.mediumHeader>
              </HideSmall>
              <ButtonRow>
                <ResponsiveButtonPrimary id="join-pool-button" as={Link} to="/add/HYPE">
                  + New Position
                </ResponsiveButtonPrimary>
              </ButtonRow>
            </TitleRow>
            <Filters
              filter={filter}
              lpLoading={lpLoading}
              switchFilter={switchFilter}
              setCurrentPage={setCurrentPage}
            />

            {!isLeverage && !isHot && (
              <Row style={{ gap: '8px' }}>
                <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} setCurrentPage={setCurrentPage} />

                {isSortableData && <SortBy sortBy={sortBy} setSortBy={setSortBy} />}
              </Row>
            )}

            <>
              {lpLoading || (isIncentives && campaignsLoading) ? (
                <MainContentWrapper>
                  <LoadingRows>
                    {Array.from({ length: 12 }).map((_, i) => (
                      <div key={i} />
                    ))}
                  </LoadingRows>
                </MainContentWrapper>
              ) : data.length > 0 ? (
                <div style={{ maxWidth: '100%', overflow: 'auto' }}>
                  {isLeverage || isHot || filter === 'v2' || filter === 'v3' || filter === 'incentives' ? (
                    <GridContainerForCard>
                      {data.map((pool: any, key: number) => {
                        return <PoolCard pool={pool} key={`${pool.token0.token0Address}-${key}`} rewards={rewards} />
                      })}
                    </GridContainerForCard>
                  ) : (
                    <GridContainerForAllCard>
                      {data.map((pool: any, key: number) => {
                        return <PoolAllCard pool={pool} key={`${pool.token0.token0Address}-${key}`} rewards={rewards} />
                      })}
                    </GridContainerForAllCard>
                  )}

                  {isSortableData && (
                    <Pagination currentPage={currentPage} pageCount={pageCount} handlePageChange={handlePageChange} />
                  )}
                </div>
              ) : (
                <MainContentWrapper>
                  <NoLiquidity>
                    <TYPE.mediumHeader color={theme.text3} textAlign="center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-photo-hexagon"
                        style={{ marginBottom: '.5rem' }}
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M15 8h.01" />
                        <path d="M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z" />
                        <path d="M3.5 15.5l4.5 -4.5c.928 -.893 2.072 -.893 3 0l5 5" />
                        <path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2.5 2.5" />
                      </svg>
                      <div>Pools not found.</div>
                    </TYPE.mediumHeader>
                  </NoLiquidity>
                </MainContentWrapper>
              )}
            </>
          </AutoColumn>
        </AutoColumn>
      </PageWrapper>
    </>
  )
}
export default ExplorePools
